// extracted by mini-css-extract-plugin
export default {"host-card__container":"styles_host-card__container__W+VKa","host-card__text--name":"styles_host-card__text--name__HnNlh"};